'use strict';

import Overlay from '../components/overlay';

export default {
    play_video(src) {
        Overlay.show_overlay();
        $('.overlay-content').append('<div class="video-holder"><iframe width="100%" height="100%" src="https://www.youtube.com/embed/'+src+'?autoplay=1&loop=1&rel=0&wmode=transparent" frameborder="0" allowfullscreen wmode="Opaque"></iframe></div>');
    }
};



// WEBPACK FOOTER //
// ./app/Resources/assets/js/components/video.js